module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"recent":"Недавно просмотренные"}}')
  delete Component.options._Ctor
}
